<template>
  <div id="occupations">
    <template v-if="currentUser.role == 'admin' && entities.length == 1 && entities[0].independent">
      <h1 class="page-title">{{ $t("Occupations.title_page") }}</h1>
      <occupation-form :currentEntity="currentEntity" />
      <occupation-list :currentEntity="currentEntity" />
    </template>

    <template v-if="currentUser.role == 'admin' && entities.length == 1 && !entities[0].independent">
      <h1 class="page-title">{{ $t("Occupations.title_page") }}</h1>
      <p class="desc">{{ $t("Occupations.guideline") }}</p>
      <occupation-group-list :currentEntity="currentEntity" />
    </template>

    <template v-if="currentUser.role == 'admin' && entities.length > 1">
      <h1 class="page-title">{{ $t("Occupations.title_page") }}</h1>
      <select-entity
        :entities="entities"
        @entity-changed="onChangeEntityId"
      />

      <p class="desc" v-if="independent == false">{{ $t("Occupations.guideline") }}</p>
      <occupation-group-list
        v-if="independent == false"
        :currentEntity="currentEntity"
      />

      <occupation-form
        v-if="independent == true"
        :currentEntity="currentEntity"
      />
      <occupation-list
        v-if="independent == true"
        :currentEntity="currentEntity"
      />
    </template>

    <template v-if="currentUser.role == 'corporation_admin'">
      <h1 class="page-title">{{ $t("Occupations.title_page") }}</h1>
      <div class="row align-items-center form-group" v-if="currentUser && currentUser.corporations.length > 1">
        <div class="col-12 col-md-5">
          <label class="control-label">
            {{ $t("Occupations.select_group") }}
          </label>
        </div>
        <div class="col-12 col-md-3">
          <multiselect v-model="currentCorporation"
            :id="'corporation_id'"
            :options="currentUser.corporations"
            label="name"
            track-by="id"
            :allow-empty="false"
            :showLabels="false"
            :placeholder="$t('multiselect.placeholder')"
            @input="onChangeCorporation">
          </multiselect>
        </div>
      </div>
      <template v-if="currentEntity">
        <ul class="nav nav-tabs nav-tabs-fillup hidden-sm-down" data-init-reponsive-tabs="dropdownfx" v-if="!currentCorporation.is_fake">
          <li class="nav-item col-4">
            <a href="#" :class="{ active: true }" data-toggle="tab" data-target="#occupation-list" aria-expanded="true">
              <span>{{ $t("Occupations.group_tab") }}</span>
            </a>
          </li>
          <li class="nav-item col-4">
            <a href="#" :class="{ active: false }" data-toggle="tab" data-target="#occupation-group" class=""
              aria-expanded="false">
              <span>{{ $t("Occupations.entity_tab") }}</span>
            </a>
          </li>
        </ul>

        <div class="tab-content">
          <div class="tab-pane slide-left" :class="{ active: true }" id="occupation-list" aria-expanded="true">
            <occupation-form :currentEntity="currentEntity" />
            <occupation-list :currentEntity="currentEntity" />
          </div>
          <div class="tab-pane slide-left" :class="{ active: false }" id="occupation-group" aria-expanded="false" v-if="!currentCorporation.is_fake">
            <select-entity
              :key="currentCorporation.id"
              :entities="entities"
              @entity-changed="onChangeEntityId"
            />
            <occupation-group-list :currentEntity="currentEntity" v-if="entitySelected"/>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script type="text/javascript">
  import OccupationForm from './OccupationForm'
  import OccupationList from './OccupationList'
  import NoData from '../common/NoData'
  import OccupationGroupList from './OccupationGroupList'
  import SelectEntity from '@/components/common/SelectEntity'
  import { getUserWithEntities } from '@/backend/users'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    components: {
      OccupationForm,
      OccupationList,
      OccupationGroupList,
      SelectEntity,
      NoData
    },
    data() {
      return {
        currentCorporation: null,
        currentEntity: null,
        entities: [],
        independent: null,
        entitySelected: false
      }
    },
    computed: {
      ...mapGetters({
        currentUser: 'auth/currentUser'
      })
    },
    methods: {
      ...mapActions({
        loadList: 'occupations/loadList',
        setList: 'occupations/setList',
      }),
      onChangeEntityId(entity) {
        this.entitySelected = true
        this.currentEntity = entity
        this.independent = entity.independent
        this.$store.dispatch('occupations/loadList', entity.id)
      },
      onChangeCorporation(corporation) {
        this.entitySelected = false
        getUserWithEntities(corporation.id).then(res => {
          this.entities = res.data.entities
          this.currentEntity = this.entities[0]
          this.loadList(this.currentEntity.id)
        })
      }
    },
    mounted: async function() {
      await this.$store.dispatch("auth/getUser");
      if(this.currentUser.role != 'corporation_admin' || this.currentUser.corporations.length <= 1) {
        this.currentCorporation = this.currentUser.corporations[0]
        getUserWithEntities().then(res => {
          this.entities = res.data.entities
          this.currentEntity = this.entities[0]
          if (this.currentUser.role == 'admin' && this.currentUser.entities.length == 1 || this.currentUser.role == "corporation_admin") {
            this.loadList(this.currentEntity.id)
          }
        })
      }
    },
    destroyed() {
      this.setList([])
    },
  }
</script>

<style lang="scss" scoped>
  .desc {
    background: #edefef;
    border-radius: 5px;
    padding: 5px 6px;
    margin: 30px 20px 30px 14px;
  }

  .tab-content {
    overflow: inherit;
  }
</style>



// WEBPACK FOOTER //
// src/components/occupations/Occupations.vue